export default "__VITE_ASSET__CYa5O9gT__"